
export const notBlank = {
    name: "not-blank",
    validate: (value) => value != null && !!value.trim?.(),
};
